import { Stack } from '@mui/material'
import {
	IMilkingProcessDeviationItem,
	IMilkingProcessStats,
} from 'models/MilkingProcess'
import { MilkingProcesDeviationsCard } from './widgets/deviations/MilkingProcessDeviationsCard'
import { MilkingIndicatorsProcess } from './widgets/indicators/MilkingIndicatorsProcess'

type InfoBlockProps = {
	stats: IMilkingProcessStats | undefined
	deviations: IMilkingProcessDeviationItem[] | undefined
	isLoading: boolean
	hasNoSourceData?: boolean
}

export const InfoBlock = (props: InfoBlockProps) => {
	const { stats, deviations, isLoading, hasNoSourceData } = props

	return (
		<Stack direction={'row'} gap={'24px'} height={'360px'}>
			<MilkingIndicatorsProcess stats={stats} isLoading={isLoading} />
			<MilkingProcesDeviationsCard
				deviations={deviations}
				isLoading={isLoading}
				hasNoSourceData={hasNoSourceData}
			/>
		</Stack>
	)
}
